<template>
  <v-dialog v-model="show" persistent width="350px">
    <v-card>
      <v-card-title v-html="title" class="headline"></v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$confirmCancel.close(false)">Cancel</v-btn>
        <v-btn color="primary" text @click="$confirmCancel.close(true)">{{this.confirm}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      color: 'info',
      title: '',
      message: '',
      confirm: 'Confirm',
    };
  },
  methods: {
    showDialog(title, message, confirm) {
      if (message !== '') {
        this.title = title;
        this.message = message;
        this.show = true;
        this.confirm = confirm || 'Confirm';
      }
    },
  },
  destroyed() {
    this.$confirmCancel.$off('show-confirm-cancel');
    this.$confirmCancel.$off('confirm-cancel');
  },
  created() {
    this.$confirmCancel.$on('show-confirm-cancel',
      (title, message, confirm) => this.showDialog(title, message, confirm));
    this.$confirmCancel.$on('confirm-cancel', () => this.show = false);
  },
};
</script>
